module.exports = __webpack_public_path__ + "img/header_logo.30c750d4.png";